<mat-card>
  <mat-card-header>
    <mat-card-title>Your active samples</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="filters">
      <div [formGroup]="filtersFormGroup">
        <suvo-bi-reference-autocomplete-selector
          referenceLabelProperty="label"
          entityDefinitionAlias="tows"
          formControlName="towId"
        />
      </div>
    </div>

    @if (count != 0) {
      <table
        mat-table
        [dataSource]="dataSource$"
        matSort
        [defaultSort]="defaultSort"
        matSortDisableClear
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="listDropped($event)"
      >
        <ng-container matColumnDef="towId">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            @if (!isLoading) {
              Tow
            }
          </th>
          <td mat-cell *matCellDef="let item">{{ item.tow?.metadata?.oldTowBaseId }}</td>
        </ng-container>

        <ng-container matColumnDef="sampleNo">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            @if (!isLoading) {
              Sample no.
            }
          </th>
          <td mat-cell *matCellDef="let item">{{ item.sampleNo }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            @if (!isLoading) {
              Status
            }
          </th>
          <td mat-cell *matCellDef="let item">
            <cpr-sample-status [sample]="item" />
          </td>
        </ng-container>

        <ng-container matColumnDef="button">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item" class="align-right">
            <button mat-button color="primary">Data Entry</button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="headings"></tr>
        <tr
          mat-row
          class="row clickable"
          [class.hidden]="isLoading"
          *matRowDef="let row; columns: headings"
          [routerLink]="['/tows', row.tow?._id, 'samples', row._id]"
        ></tr>

        <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
          <td class="mat-cell" [attr.colspan]="headings.length">
            <span>No matching data.</span>
          </td>
        </tr>
      </table>
    }

    @if (isLoading) {
      <suvo-skeleton-table-rows [rowCount]="pageSize" [colWidths]="widths" />
    }

    @if (count != 0) {
      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
      />
    }
  </mat-card-content>
</mat-card>
